module.exports = __webpack_public_path__ + "static/media/fi.1b298415.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/fi.svg
// module id = 858
// module chunks = 0